import { useState, useRef, useEffect } from "react";
import Masters_header from './Masters_header';
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { ToastContainer, toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import DesignationCreation from "./DesignationCreation";
import axiosInstance from "../../axiosInstance";
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import CommonFooter from "../../CommonFooter/CommonFooter";

const Designation = () => {

  let ModuleId = 5
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableData, setTableData] = useState([]);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentDesignation, setCurrentDesignation] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const popupRef = useRef(null);
  const totalPages = Math.ceil(totalCount / limit);
  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;
  const [skip, setSkip] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);


  useEffect(() => {
    fetchDesignations(searchTerm);
  }, [currentPage, limit]);


  const fetchDesignations = async (term = '') => {
    try {
      const response = await axiosInstance.get('/designation/list', {
        params: {
          limit,
          skip: currentPage * limit,
          search: term || undefined,
        }
      });
      setTableData(response.data.designation || []);
      setTotalCount(response.data.totalCount || 0);
    } catch (error) {
      toast.error("Failed to fetch designations");
      console.error("Error fetching designations:", error);
    }
  };

  const handleAddNewClick = () => {
    setIsEditMode(false);
    setCurrentDesignation(null);
    setIsPopupOpen(true);
  };


  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleSelectAll = () => {
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setCurrentPage(0);
  };

  const handleCreateDesignation = async (formData) => {
    try {
      if (isEditMode && currentDesignation) {
        // Update existing designation - note the endpoint change
        await axiosInstance.put('/designation/update', {
          ...formData,
          id: currentDesignation.id // Make sure to include the ID in the body
        });
        toast.success("Designation updated successfully");
      } else {
        // Create new designation
        await axiosInstance.post('/designation/save', formData);
        toast.success("Designation created successfully");
      }
      fetchDesignations();
      setIsPopupOpen(false);
    } catch (error) {
      toast.error("Failed to save designation");
      console.error("Error saving designation:", error);
    }
  };

  const handleDeleteDesignation = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };


  const confirmDelete = async () => {
    if (!deleteId) return
    {
      try {
        await axiosInstance.delete(`/designation/delete/${deleteId}`);
        toast.success("Designation deleted successfully");
        fetchDesignations();
      } catch (error) {
        toast.error("Failed to delete designation");
        console.error("Error deleting designation:", error);
      } finally {
        setConfirmOpen(false);
        setDeleteId(null);
      }
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setDeleteId(null);
  };

  const handleEditClick = async (designation) => {
    try {
      const response = await axiosInstance.get(`/designation/edit/${designation.id}`);
      setCurrentDesignation(response.data.designation); // Assuming the API returns the full designation object
      setIsEditMode(true);
      setIsPopupOpen(true);
    } catch (error) {
      toast.error("Failed to fetch designation details");
      console.error("Error fetching designation:", error);
    }
  };

  // Close popup on outside click
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isPopupOpen]);

  const handleSearch = async (term) => {
    setSearchTerm(term);
    setSkip(0);
    await fetchDesignations(term);
  };


  return (
    <>
      <Masters_header onSearch={handleSearch} />
      <div className="container">
        <div className="header d-flex justify-content-between">
          <h3>Designation: {totalCount}</h3>

          <PermissionWrapper permissionKey="create_permission" moduleId={ModuleId}>
            {!isAnySelected && (
              <button id="addNewBtn" onClick={handleAddNewClick}>Add New</button>
            )}
          </PermissionWrapper>

        </div>
        <div className="user-table" style={{ overflowX: 'auto', scrollBehavior: 'smooth' }}>
          <table>
            <thead>
              <tr>
                {/* <th>
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                      />
                    </th> */}
                <th>S.No</th>
                <th>Code</th>
                <th>Name</th>
                <th>Description</th>
                <th>Modified Date</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={row.id}>
                  {/* <td>
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(row.id)}
                          onChange={() => handleRowSelect(row.id)}
                        />
                      </td> */}
                  <td>{skip + index + 1}</td>
                  <td>{row.designation_code}</td>
                  <td>{row.designation_name}</td>
                  <td>{row.description}</td>
                  <td>{row.modifieddate}</td>
                  <td></td>
                  <td></td>
                  <td>
                    <div className="actions">

                      <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                        <span
                          className="edit-icon"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleEditClick(row)}
                        >
                          <img src={Vector} alt="Edit" width="20" height="20" />
                        </span>
                      </PermissionWrapper>


                      <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                        <span
                          className="delete-icon"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDeleteDesignation(row.id)}
                        >
                          <img src={Delete} alt="Delete" width="40" height="40" />
                        </span>
                      </PermissionWrapper>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {searchTerm && tableData.length === 0 && (
            <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
              No Designation found matching "{searchTerm}"
            </div>
          )}

        </div>

        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel={<span style={{ userSelect: "none" }}>Previous</span>}
              nextLabel={<span style={{ userSelect: "none" }}>Next</span>}
              pageCount={totalPages > 0 ? totalPages : 1}
              onPageChange={handlePageClick}
              containerClassName={"pagination d-flex"}
              activeClassName={"active"}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              forcePage={currentPage}
            />
          </div>
        </div>
      </div>

      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <DesignationCreation
              onClose={handleClosePopup}
              onSubmit={handleCreateDesignation}
              isEditMode={isEditMode}
              initialData={currentDesignation}
            />
          </div>
        </div>
      )}
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmOpen}
        title="Delete Confirmation"
        message="Are you sure you want to delete this Designation?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default Designation;